export default {
	teamMark: "Team",
	oneOnOneMark: "1:1",
};
